import { QueryKeys } from 'queries/types'

const ROOT = 'app'

export const appKeys = {
  root: [ROOT],
  latestVersion: [ROOT, 'latestVersion'],
} satisfies QueryKeys
